// extracted by mini-css-extract-plugin
export default {"wrapper":"BluePill_wrapper__OwOmD","btn":"BluePill_btn__tgODD","text":"BluePill_text__Y8qcJ"};